import $ from 'jquery';
import { gsap } from 'gsap';

import { $Elements, Events } from '../global/constants';

// ---------- Init Base Animation ----------

export const initBaseAnimations = () => {

	// ---------- Animations ----------

	$('.scroll-text-section .scroll-content').each(function() {

		gsap.to(this, {
			duration: 7,
			ease: 'none',
			x: "-=25%",
			repeat: -1
		});
	});

};

$Elements.document.on(Events.page.enter, () => initBaseAnimations());
